import { render, staticRenderFns } from "./best-picks.vue?vue&type=template&id=12ce7bb3&scoped=true"
import script from "./best-picks.vue?vue&type=script&lang=js"
export * from "./best-picks.vue?vue&type=script&lang=js"
import style0 from "./best-picks.vue?vue&type=style&index=0&id=12ce7bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ce7bb3",
  null
  
)

export default component.exports